import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import {Consumer} from '@emm/core/models/consumer.model';
import {LocationSet} from '@emm/core/models/location-set.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-menu-header',
    styleUrls: ['./menu-header.component.scss'],
    templateUrl: './menu-header.component.html',
    standalone: false
})
export class MenuHeaderComponent implements OnInit {

    @Input() isEmpty: boolean;
    @Input() readonly: boolean;
    @Input() selectedConsumer: Consumer;
    @Input() selectedLocation: LocationSet;

    @Output() add = new EventEmitter();
    @Output() collapse = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

}
